
import './index.css';
import { Link } from 'react-router-dom';

const SpotlightSection = () => {
  const property = {
    title: "Newly Launched: Sunny Woodla",
    details: "12-16 Guests • 6 Bedrooms • 6 Bathrooms • Century-old 6-B Bungalow • Kodaikanal private",
    description: "Sunny Woodla is a century-old 6-bedroom bungalow nestled in the misty hills of Kodaikanal, offering a private escape into nature’s lap. This heritage property has been lovingly restored to retain its colonial charm, with wooden floors, high ceilings, and large windows that frame breathtaking views of the surrounding forests and valleys. Guests can spend their days exploring nearby attractions like the Kodaikanal Lake or simply relax by the fireplace with a cup of local tea. The sprawling gardens are perfect for morning walks, while the in-house chef prepares delicious meals using fresh, local ingredients, making every moment at Sunny Woodla truly unforgettable.",
    image: "https://firebasestorage.googleapis.com/v0/b/phone-auth-d0a8d.appspot.com/o/Luxeunbounded%2FInvest%20%26%20Own%20image%201.jpg?alt=media&token=247cc3b2-2923-46b2-9ea5-1d731e602ed6",
};

  return (
    <div className="spotlight-container">
      <div className="spotlight-content">
        <h2 className="spotlight-title">{property.title}</h2>
        <p className="spotlight-details">{property.details}</p>
        <p className="spotlight-description">{property.description}</p>
        <Link to="/villa/sunny-woodla">
          <button className="spotlight-button">KNOW MORE</button>
        </Link>
      </div>
      <div className="spotlight-image-section">
        <img
          src={property.image}
          alt="Property"
          className="spotlight-image"
          onError={(e) => (e.target.src = "https://via.placeholder.com/400x400?text=No+Image")}
        />
      </div>
    </div>
  );
};

export default SpotlightSection;